module.exports = __webpack_public_path__ + "static/media/rMacd.e61e7b9b.png";